import React from 'react';
import { FcOk } from "react-icons/fc";

const SipandPaint = () => {
  return (
    <div className="bg-[#f4f1e9] overflow-x-hidden">
      
      {/* Hero Section */}
      <div className="relative h-[100%] md:h-[350px] overflow-x-hidden">
        <img
          src="assets/sipandpaint/banner.png"
          alt="Content creator filming weddings for Date Saver Co"
          className="w-full h-full md:object-cover sm:object-cover object-contain"
        />
      </div>

      <div className="py-11 text-center font-columbia-serial text-sm md:text-lg overflow-x-hidden">
        
        <div className="lg:max-w-[40%] lg:mx-auto md:mx-44 sm:mx-11 mx-11 overflow-x-hidden">
          
          <h1 className="text-xl font-medium pb-8 text-center font-the-seasons">
            SIP AND PAINT
          </h1>

          <div className="text-justify pb-7">
            <p className="pb-5">
              Come join us for a LABUBU-themed SIP & PAINT Event hosted by Bonchon Rockville and Date Saver Co.
            </p>
            <p className="pb-5">
              Get mingling with fellow Labubu enthusiasts! Shared interests make for easy conversation. (no small talk needed yayyyy)
            </p>
            <p className="pb-5">
              And for those feeling lucky… there may be a chance to take home something special 👀✨
            </p>
            <p>
              You may even have an opportunity to purchase Labubus !!! <br />
              Shhh.... 🤫 Don’t miss out!
            </p>
          </div>

          <div className="pb-5 text-center">
            <h2 className="font-bold">Location:</h2>
            <p>Bonchon Rockville</p>
            <a
              className="underline"
              href="https://maps.app.goo.gl/B87xhWEhPMPcj3bLA"
              target="_blank"
              rel="noreferrer"
            >
              107 Gibbs St Unit A Rockville MD 20850
            </a>
          </div>

          <div className="pb-5 text-center">
            <h2 className="font-bold">Food:</h2>
            <p>
              1 drink is included with your ticket. <br />
              Event exclusive food and drink specials will be available for purchase during the event!
            </p>
          </div>

          <h2 className="text-xl font-medium text-center font-the-seasons pt-8 pb-4">
            EACH TICKET INCLUDES
          </h2>

          <div className="text-md px-4 mx-auto max-w-[600px] flex flex-col items-center gap-4 text-center">
            
            <div className="flex flex-col items-center">
              <FcOk className="text-xl mb-2" />
              <p>1 PRE-SKETCHED canvas</p>
            </div>

            <div className="flex flex-col items-center">
              <FcOk className="text-xl mb-2" />
              <div>
                <p>1 DRINK included</p>
                <p className="text-xs">(alcoholic or non-alcoholic)</p>
                <p className="text-xs">additional drinks available for purchase on-site</p>
              </div>
            </div>

            <div className="flex flex-col items-center">
              <FcOk className="text-xl mb-2" />
              <p>PAINT SUPPLIES provided 🎨</p>
            </div>

            <div className="flex flex-col items-center">
              <FcOk className="text-xl mb-2" />
              <p>A CHANCE TO WIN LABUBU ₍ᐢ..ᐢ₎</p>
            </div>

          </div>

          <div className="pt-5">
            <a
              href="https://drive.google.com/file/d/1Ty_aNhDFSNQqwC0cb6UErYRiWYeYQy34/view?usp=sharing"
              className="text-sm underline italic"
              target="_blank"
              rel="noreferrer"
            >
              Click here to read the Terms & Conditions
            </a>
          </div>

        </div>
      </div>

      {/* 
        Product cards available in github 
      */}

        <h1 className="md:text-5xl sm:text-3xl text-2xl font-medium text-center font-the-seasons pt-8 md:pt-8 md:pb-8 mb-8">
          SELECT YOUR CANVAS DESIGN
          <p className='md:text-sm text-xs'>
            Click “Book” to select the design of your choice.
          </p>
        </h1>

      {/* Acuity Scheduling iframe */}
      <div className="mb-10 md:max-w-[60%] max-w-[95%] max-h-[3500px] mx-auto overflow-hidden">
        <iframe
          src="https://app.acuityscheduling.com/schedule.php?owner=33469695&appointmentType=category:Sip%20and%20Paint%20%284th%29"
          title="Schedule Appointment"
          className="w-full h-[3000px] md:h-[1350px] rounded-xl"
          style={{ border: 'none' }}
        >
          <script src="https://embed.acuityscheduling.com/js/embed.js" type="text/javascript"></script>
        </iframe>
      </div>


    </div>
  );
};

export default SipandPaint;
